"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLMarqueeElementImpl extends HTMLElementImpl { }

module.exports = {
  implementation: HTMLMarqueeElementImpl
};
